<h1 mat-dialog-title>{{ orgName }} Program Access</h1>

<div class="closeBtn" (click)="closeModal()">
    <img src="../../../../../assets/images/crossbtn.svg" />
</div>
<div mat-dialog-content>
  <div class="search_box">
    <input type="text" placeholder="Search" [(ngModel)]="searchQuery" (input)="searchAndExpand()">
  </div>

    <div class="content_box" *ngFor="let category of filteredCategories?.length ? filteredCategories : categories">


        <h3 class="categ_head">{{category.name}}</h3>
        <mat-accordion>
          <mat-expansion-panel *ngFor="let subCategory of category.subCategories; let i = index" [expanded]="filteredCategories.length > 0">
            <mat-expansion-panel-header>
              <mat-panel-title>
                <div class="ques">
                  {{i+1}}. {{subCategory.name}}
                </div>
              </mat-panel-title>
            </mat-expansion-panel-header>
            <div class="answer">
              <div class="header row">
                <span class="column-6">Program Name</span>
                <span class="column-2">Show Program</span>
                <span class="column-2">Allow Access</span>
              </div>
              <div class="row" *ngFor="let program of subCategory.programs">
                <span class="column-6">{{program.name}}</span>
                <span class="column-2">
                  <mat-slide-toggle [disabled]="isPublishedFalse(program)" [checked]="!isHiddenProgram(program.id)"
                  (change)="toggleHiddenProgram(program.id)"></mat-slide-toggle>
                </span>
                <span class="column-2">
                  <mat-slide-toggle [checked]="isAllowedProgram(program.id) && !isHiddenProgram(program.id)"
                  (change)="toggleAllowedProgram(program.id, $event)"></mat-slide-toggle>
                </span>
              </div>
            </div>
          </mat-expansion-panel>
        </mat-accordion>
      </div>



</div>